/** A touch that may become an upward swipe from the status bar. */
export interface StatusBarTouch {
	x: number;
	y: number;
	width: number;
}

/** Far enough that a tap which drifted upwards does not count as a swipe. */
const SWIPE_DISTANCE_PX = 40;

export function statusBarSwipeTarget(start: StatusBarTouch, currentY: number): "settings" | "alerts" | null {
	if (start.y - currentY <= SWIPE_DISTANCE_PX) {
		return null;
	}
	if (start.x < start.width / 3) {
		return "settings";
	}
	if (start.x > (start.width * 2) / 3) {
		return "alerts";
	}
	return null;
}